import { Box, Typography, Tooltip } from '@mui/material';

const sizes = {
  tabs: {
    xs: '2px 16px',
    s: '4px 16px',
    m: '6px 16px',
  },
  container: {
    xs: 0,
    s: '1px',
    m: '2px',
  },
};

export default function BoxedTabs({ tabs, selectedTab, handleChange, size = 'm' }) {
  return (
    <Box
      className="bg-neutral-200 rounded border border-border flex gap-2"
      style={{ padding: sizes.container[size] }}
    >
      {tabs.map((tab) => (
        <Box
          key={tab.value || 'all'}
          className={`rounded transition-colors font-500 text-14 ${
            tab.value === selectedTab
              ? 'bg-white select-none shadow-[0px_1px_1px_0px_#00000029] text-primary-dark'
              : 'cursor-pointer text-typography-primary'
          }`}
          style={{ padding: sizes.tabs[size] }}
          onClick={() => handleChange(tab.value)}
        >
          {tab.tooltip && (
            <Tooltip title={tab.tooltip} arrow>
              <Typography variant="span">{tab.label}</Typography>
            </Tooltip>
          )}
          {!tab.tooltip && <Typography variant="span">{tab.label}</Typography>}
          {tab.badge > 0 && (
            <Box className="ml-10 inline-block h-16 px-6 rounded-full bg-typography-danger">
              <Typography className="text-white font-500 text-12">{tab.badge}</Typography>
            </Box>
          )}
          {tab.count !== undefined && (
            <Typography className="ml-4" variant="span">
              ({tab.count})
            </Typography>
          )}
        </Box>
      ))}
    </Box>
  );
}
